import React from 'react';
import {
	Space,
	Typography,
} from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/pro-light-svg-icons';
import { AccountingItemApprovalStates } from '@shared/utils/constants';
import { Values } from '@shared/utils/objectEnums';
import Button from '@client/components/Button';
import styles from './styles/ExpenseActionButtons.module.css';

type Props = {
	expense: {
		amount: number | null;
		state: Values<typeof AccountingItemApprovalStates> | string;
		estimated?: boolean | undefined;
	};
	onSubmitExpense: () => void;
	onUnsubmitExpense: () => void;
	showTitle?: boolean;
};

const ExpenseActionButtons = ({
	expense,
	onSubmitExpense,
	onUnsubmitExpense,
	showTitle = true,
}: Props) => {
	let buttons = null;

	const readyForApproval = expense.amount != null && !expense.estimated;
	let tooltip = '';

	if (expense.amount == null) {
		tooltip = 'Expense amount needs to be specified';
	}

	if (expense.estimated) {
		tooltip = 'Estimated expenses cannot be submitted';
	}

	switch (expense.state) {
		case AccountingItemApprovalStates.PENDING:
			buttons = (
				<Button
					type='link'
					size='small'
					icon={(<CheckOutlined />)}
					disabled={!readyForApproval}
					disabledTooltip={tooltip}
					onClick={onSubmitExpense}
				>
					Submit for approval
				</Button>
			);
			break;

		case AccountingItemApprovalStates.REJECTED:
		case AccountingItemApprovalStates.SUBMITTED:
			buttons = (
				<Button
					onClick={onUnsubmitExpense}
					icon={(
						<FontAwesomeIcon
							icon={faUndo}
							className={styles.buttonIcon}
						/>
					)}
					type="link"
				>
					Undo Submit
				</Button>
			);
			break;

		case AccountingItemApprovalStates.APPROVED:
			buttons = (
				<Button
					onClick={onUnsubmitExpense}
					icon={(
						<FontAwesomeIcon
							icon={faUndo}
							className={styles.buttonIcon}
						/>
					)}
					type="link"
				>
					Undo Submit
				</Button>
			);
			break;

		default:
			return null;
	}

	if (showTitle) {
		return (
			<>
				<Typography.Title level={5}>Expense Actions</Typography.Title>
				<Space>
					{buttons}
				</Space>
			</>
		);
	}

	return buttons;
};

export default ExpenseActionButtons;
